<template>
  <div class="myCard">
    <header-info-card
      :interFollow="interFollowed"
      :editMode="editMode"
      @close="close()"
      v-if="alone"
    ></header-info-card>

    <div class="infos-view">
      <div class="employee-city">
        <div class="line employee">
          <div class="field">
            {{ $t("editEventCard.trainer") }}
          </div>
          <div class="data">
            {{ interFollowed.details.advInterventionDto.user.fullName }}
          </div>
        </div>
        <div class="line employee">
          <div class="field">
            {{ $t("editEventCard.employee") }}
          </div>
          <div class="data">
            {{ interFollowed.userName }}
          </div>
        </div>
        <div class="line city">
          <div class="field">
            {{ $t("editEventCard.location") }}
          </div>
          <div
            class="data"
            :style="{
              color: interFollowed.details.advInterventionDto.location.color,
            }"
          >
            {{ interFollowed.details.advInterventionDto.location.city }}
          </div>
        </div>
      </div>

      <div class="dates-times">
        <div class="line dates">
          <div class="field">
            {{ $t("editEventCard.date") }}
          </div>
          <div class="data">
            <div class="data">
              {{ $t("editEventCard.from") }}
              {{ interFollowed.details.advInterventionDto.dateStart }}
            </div>
            <div class="data">
              {{ $t("editEventCard.to") }}
              {{ interFollowed.details.advInterventionDto.dateEnd }}
            </div>
          </div>
        </div>
      </div>
      <div class="line type">
        <div class="field">
          {{ $t("editEventCard.types") }}
        </div>
        <div class="data">
          {{ interFollowed.details.advInterventionDto.type }}
        </div>
      </div>
      <div
        v-if="interFollowed.details.advInterventionDto.comment"
        class="comment"
      >
        <div class="field">
          {{ $t("editEventCard.comment") }}
        </div>

        <div class="data">
          {{ interFollowed.details.advInterventionDto.comment }}
        </div>
      </div>

      <div class="line valid">
        <div class="field">{{ $t("editEventCard.status") }}</div>
        <div class="data">
          {{
            interFollowed.details.advInterventionDto.validated
              ? $t("editEventCard.validatedTrue")
              : $t("editEventCard.validatedFalse")
          }}
        </div>
      </div>
      <div class="line attendees">
        <div class="field">{{ $t("editEventCard.attendeesCount") }}</div>
        <div class="data">
          {{ interFollowed.details.advInterventionDto.attendeesCount }}
        </div>
      </div>
      <div class="line attendees">
        <div class="field">{{ $t("editEventCard.customers") }}</div>
        <div class="data">
          {{ interFollowed.details.advInterventionDto.customers }}
        </div>
      </div>
      <div class="line duration">
        <div class="field">{{ $t("editEventCard.courseDuration") }}</div>
        <div class="data">
          {{ interFollowed.duration }}
        </div>
      </div>

      <div
        v-if="
          interFollowed.details.advInterventionDto.slug != null &&
          interFollowed.details.advInterventionDto.optionSlug == null
        "
        class="line master"
      >
        <div class="field">{{ $t("editEventCard.slug") }} :</div>
        <div class="data">
          <a
            target="_blank"
            :href="
              Links.DawanOrgShowTrainingSession(
                interFollowed.details.advInterventionDto.slug.split(
                  '-customers-'
                )[0]
              )
            "
            >{{
              interFollowed.details.advInterventionDto.slug.split(
                "-customers-"
              )[0]
            }}</a
          >
        </div>
      </div>

      <div v-if="interFollowed.registrationSlug" class="line master">
        <div class="field">{{ $t("editEventCard.registrationSlug") }}</div>
        <div class="data">
          {{ interFollowed.registrationSlug }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerInfoCard from "./headerInfoCard.vue";
import Links from "@/models/Links";

export default {
  components: {
    headerInfoCard,
  },
  name: "intervention-followed-info",
  props: {
    interFollowed: {
      y: null,
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
    },
    alone: false,
    editMode: null,
  },
  data() {
    return {
      Links: Links,
    };
  },
  methods: {
    close() {
      this.$emit("closeCard");
    },
  },
};
</script>

<style lang="scss">
.infos-view {
  padding: 0 10px 0 0;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin: 20px 10px 0;

  .line {
    display: flex;
    justify-content: space-between;
    padding: 0 0 15px;
    margin: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .field {
    color: rgb(155, 155, 155);
  }

  .comment {
    text-align: justify;
    margin: 0 0 15px;
    padding: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .master {
    .data {
      text-align: right;
    }
  }
}
</style>
